import { Component, EventEmitter, Output } from '@angular/core';
import { CerrixSearchInputComponent } from '@app/shared/atoms/cerrix-search-input/cerrix-search-input.component';
import { CerrixIconButtonComponent } from '../cerrix-icon-button/cerrix-icon-button.component';

@Component({
  selector: 'cerrix-add-and-filter-bar',
  templateUrl: './cerrix-add-and-filter-bar.component.html',
  styleUrls: ['./cerrix-add-and-filter-bar.component.scss'],
  imports: [
      CerrixSearchInputComponent,
      CerrixIconButtonComponent
  ],
})
export class CerrixAddAndFilterBarComponent {
  @Output() addButtonClicked: EventEmitter<void> = new EventEmitter();
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

}
